<div id="add-carrier-certificate" class="add-certificate">
  <div class="modal-header">
    <h2 class="modal-title">{{ 'SHARED.UPLOAD-CARRIER-CERTIFICATE' | translate }} </h2>
  </div>

  <form class="modal-body" #expirationDateForm="ngForm">
    <div class="row">
      <div class="col-8 offset-2">
        <mat-form-field class="mobile-font-size-details-on-blue" appearance="outline">
           <mat-label>{{ 'SHARED.CHOOSE-EXPIRATION-DATE' | translate }}</mat-label>
          <input     
            class="loading-dates"
            readonly
            [min]="this.minimumDate"
            [(ngModel)]="expDate"
            [ngModelOptions]="{standalone: true}"
            matInput
            [matDatepicker]="picker"
            required
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button type="submit" class="btn btn-success answer-button" (click)="confirmAction()">
      {{'SHARED.MODAL-SAVE' | translate}}
    </button>
    <button type="button" class="btn btn-outline-dark answer-button" (click)="activeModal.dismiss();">
      {{'SHARED.MODAL-CANCEL' | translate}}
    </button>
  </div>
</div>